import { render, staticRenderFns } from "./PropertyOrOrganizationUpdateConfig.vue?vue&type=template&id=492eb242&"
import script from "./PropertyOrOrganizationUpdateConfig.vue?vue&type=script&lang=ts&"
export * from "./PropertyOrOrganizationUpdateConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports